var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subject"},[_c('layoutContainer',[_c('div',{staticClass:"video"},[_c('video',{attrs:{"id":"player-container-id","width":"1200","height":"675","preload":"auto","playsinline":"","webkit-playsinline":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }